<template lang="html">
  <div ref="container" class="container">
    <div class="input-card" style="width:11rem;">
      <div class="input-item">
        <label
          ><el-checkbox v-model="showGH" @change="showLine"
            >规划路线：</el-checkbox
          ></label
        >
        <div class="line" style="background-color: green;" />
      </div>
      <div class="input-item">
        <label
          ><el-checkbox v-model="showZJ" @change="showLine"
            >北斗轨迹：</el-checkbox
          ></label
        >
        <div class="line" style="background-color: blue;" />
      </div>
      <div class="input-item">
        <label
          ><el-checkbox v-model="showAPP" @change="showLine"
            >APP轨迹：</el-checkbox
          ></label
        >
        <div class="line" style="background-color: yellow;" />
      </div>
    </div>
    <el-amap
      :vid="type"
      :amap-manager="amapManager"
      :zoom="myMap.zoom"
      :center="myMap.center"
      :events="myMap.events"
      :plugin="myMap.plugin"
    />
  </div>
</template>

<script>
import Vue from "vue";
import VueAMap from "vue-amap";
let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
let AMapKey = "";
if (dataBranch) {
  if (dataBranch.partyGroupConfigCacheMap.amapKey_webJs) {
    AMapKey = dataBranch.partyGroupConfigCacheMap.amapKey_webJs.configValue;
  }
  if (dataBranch.partyGroupConfigCacheMap.amapKey_webJs_security) {
    window._AMapSecurityConfig = {
      securityJsCode:
        dataBranch.partyGroupConfigCacheMap.amapKey_webJs_security.configValue
    };
  }
}
VueAMap.initAMapApiLoader({
  key: AMapKey,
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.Geocoder",
    "AMap.Driving"
  ],
  v: "1.4.4",
  uiVersion: "1.0"
});
Vue.use(VueAMap);
import { AMapManager, lazyAMapApiLoaderInstance } from "vue-amap";
const amapManager = new AMapManager();

import { setting } from "../../../../basicInfo/menu3/vehicleTrack/MyMap4Mobile.js";
import { vAllHisTrack4Order } from "@/api/vehiclemap";
require("echarts/theme/macarons");
import "@/assets/vehicle_map/icon.css";
export default {
  props: {
    type: {
      type: String,
      default: ""
    },
    orderCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showGH: true,
      showZJ: true,
      showAPP: true,
      tryLoad: 0,
      tryLoadPlan: 0,
      loading: false,
      container: {
        width: 0,
        height: 0
      },
      amapManager,
      lazyAMapApiLoaderInstance,
      myMap: setting(this),
      geocoder: {},
      driving: {},
      markers: [],
      firstPath: "",
      linePath: [], //路径坐标数组
      passedPath: [], //经过路径坐标数组
      linePoints: [], //路径点信息数组
      startPoint: [], //起点坐标
      endPoint: [], //终点坐标
      takePoint: [], //接单点坐标
      currentPoint: {}, //路径回放，当前点位信息
      distance: 0, //路径距离
      movedDistance: 0, //移动的距离
      lineLength: 0, //路径点数组长度
      lineIndex: 0, //路径回放，当前点位序号
      lineSpeed: 100, //路径回放，当前速度
      sliderVal: 0, //路径长度移动百分比
      searchForm: {
        orderCode: "6ae87948c1734b51a743a240c625847c"
      },
      activeName: "analyze",
      zjData: {},
      appData: {}
    };
  },
  created() {
    this.searchForm.orderCode = this.orderCode;
  },
  mounted() {
    this.getMarkPath();
  },
  methods: {
    selfAdaption() {
      this.container.width = document.documentElement.clientWidth;
      this.container.height = document.documentElement.clientHeight;
    },
    getMarkPath(orderCode) {
      //console.log(orderCode)
      if (orderCode) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        vAllHisTrack4Order({ orderCode: orderCode })
          .then(response => {
            const map = response.data;
            let takePoint = map.takePoint;
            let startPoint = map.startPoint;
            let endPoint = map.endPoint;
            let zjLine = map.zjLine,
              zjPath;
            let appLine = map.appLine,
              appPath;
            let hadTrack = false;
            if (zjLine && zjLine.length > 0) {
              hadTrack = true;
              zjPath = this.loadLine(zjLine);
              this.zjData = {
                name: "北斗轨迹",
                path: zjPath,
                pathInfo: zjLine,
                lineColor: "blue"
              };
            }
            if (appLine && appLine.length > 0) {
              appPath = this.loadLine(appLine);
              hadTrack = true;
              this.appData = {
                name: "APP轨迹",
                path: appPath,
                pathInfo: appLine,
                lineColor: "yellow"
              };
            }
            this.startPoint = startPoint;
            this.endPoint = endPoint;
            this.takePoint = takePoint;
            this.showLine();
            if (!hadTrack) {
              this.$message({ message: "未查询到轨迹！", type: "error" });
            }
            loading.close();
          })
          .catch(() => {
            loading.close();
          });
      }
    },
    showLine() {
      this.map.clearMap();
      const self = this;
      if (this.takePoint && this.takePoint[0]) {
        this.addMark(
          self,
          self.takePoint,
          require("@/assets/vehicle_map/image/mark_take.png")
        );
      }
      if (this.startPoint && this.startPoint[0]) {
        this.addMark(
          self,
          self.startPoint,
          require("@/assets/vehicle_map/image/mark_star_g.png")
        );
      }
      if (this.endPoint && this.endPoint[0]) {
        this.addMark(
          self,
          self.endPoint,
          require("@/assets/vehicle_map/image/mark_stop_g.png")
        );
      }

      let data = [];
      if (this.showGH) {
        this.drawPlanLine(this, this.startPoint, this.endPoint);
      }
      if (this.showZJ) {
        if (this.zjData && this.zjData.path) {
          this.addMark(
            self,
            self.zjData.path[0],
            require("@/assets/vehicle_map/image/mark_star_b.png")
          );
          this.addMark(
            self,
            self.zjData.path[self.zjData.path.length - 1],
            require("@/assets/vehicle_map/image/mark_stop_b.png")
          );
          data.push(this.zjData);
        }
      }
      if (this.showAPP) {
        if (this.appData && this.appData.path) {
          this.addMark(
            self,
            self.appData.path[0],
            require("@/assets/vehicle_map/image/mark_star_y.png")
          );
          this.addMark(
            self,
            self.appData.path[self.appData.path.length - 1],
            require("@/assets/vehicle_map/image/mark_stop_y.png")
          );
          data.push(this.appData);
        }
      }
      this.addLine(this, data);
    },
    addMark(self, point, img) {
      self.markers.push(
        new AMap.Marker({
          map: self.map,
          position: point,
          icon: new AMap.Icon({
            size: new AMap.Size(19, 31),
            image: img,
            imageSize: new AMap.Size(19, 31)
          }),
          offset: new AMap.Pixel(-9, -31),
          autoRotation: true,
          angle: 0
        })
      );
    },
    loadLine(list) {
      if (list && list.length > 0) {
        /*this.lineLength = list.length;
          this.linePoints = list;*/
        let linePath = [];
        for (let i in list) {
          linePath.push([list[i].longitude, list[i].latitude]);
        }
        return linePath;
      } else {
        this.$message({ message: "未查询到轨迹！", type: "error" });
      }
    },
    addLine(self, data) {
      try {
        AMapUI.load(["ui/misc/PathSimplifier", "lib/$"], function(
          PathSimplifier,
          $
        ) {
          if (!PathSimplifier.supportCanvas) {
            this.$message({
              message: "当前环境不支持 Canvas！",
              type: "warning"
            });
            return;
          }
          let pathSimplifierIns = self.pathSimplifierIns
            ? self.pathSimplifierIns
            : new PathSimplifier({
                zIndex: 100,
                map: self.map, //所属的地图实例
                getPath: function(pathData, pathIndex) {
                  return pathData.path;
                },
                getHoverTitle: function(pathData, pathIndex, pointIndex) {
                  let point = pathData.pathInfo[pointIndex];
                  const name = pathData.name;
                  if (pointIndex > 0 && point.locationTime && point.speed) {
                    return `${name}<br/>时间：${point.locationTime}<br/>速度：${
                      point.speed
                    }`;
                  }
                },
                renderOptions: {
                  renderAllPointsIfNumberBelow: 100, //绘制路线节点，如不需要可设置为-1
                  eventSupport: true,
                  pathLineStyle: {
                    dirArrowStyle: true
                  },
                  getPathStyle: function(pathItem, zoom) {
                    return {
                      pathLineStyle: {
                        lineWidth: 2,
                        fillStyle: null,
                        strokeStyle: "block",
                        borderStyle: pathItem.pathData.lineColor
                      }
                    };
                  }
                }
              });
          self.pathSimplifierIns = pathSimplifierIns;
          //设置数据
          pathSimplifierIns.setData(data);
          if (data && data.length > 0) {
            //对第一条线路（即索引 0）创建一个巡航器
            var navg = pathSimplifierIns.createPathNavigator(0, {
              loop: true, //循环播放
              speed: 10000, //巡航速度，单位千米/小时
              pathNavigatorStyle: {
                width: 24, //图中小车宽度
                height: 48, //图中小车高度
                //使用图片
                content: PathSimplifier.Render.Canvas.getImageContent(
                  require("@/assets/vehicle_map/image/truck.png")
                ),
                strokeStyle: null,
                fillStyle: null,
                //经过路径的样式
                pathLinePassedStyle: {
                  lineWidth: 4,
                  strokeStyle: "black",
                  dirArrowStyle: {
                    stepSpace: 15,
                    strokeStyle: "red"
                  }
                }
              }
            });
            navg.start();
          }
        });
      } catch (err) {
        window.setTimeout(function() {
          if (self.tryLoad < 10) {
            self.addLine(self, data);
            self.tryLoad++;
          }
        }, 200);
      }
    },
    drawPlanLine(self, start, end) {
      try {
        if (!self.map) {
          //map没有初始化完成时继续等待其初始化完成
          throw "wait";
        }
        AMap.plugin(["AMap.Driving"], function() {
          var drivingOption = {
            policy: AMap.DrivingPolicy.LEAST_TIME,
            size: 3, // 车型大小，必填，1-4分别对应小型至大型
            autoFitView: true,
            hideMarkers: true,
            map: self.map
          };
          var driving = new AMap.Driving(drivingOption); //构造驾车导航类
          driving.search(start, end, function(status, result) {
            //这里不知道为啥路线居然不用自己画。。。。。。。 = =!
            if (status === "complete") {
              /*if (result.routes && result.routes.length) {
                  self.drawRoute(self,result.routes[0]);
                  //console.log('绘制驾车路线完成')
                }*/
            } else {
              if (result == "INSUFFICIENT_ABROAD_PRIVILEGES") {
                self.$message({
                  message: "获取规划路线失败：国外权限不足！",
                  type: "error"
                });
              } else {
                self.$message({
                  message: "获取规划路线失败：" + result,
                  type: "error"
                });
              }
            }
          });
        });
      } catch (err) {
        window.setTimeout(function() {
          if (self.tryLoadPlan < 10) {
            self.drawPlanLine(self);
            self.tryLoadPlan++;
          }
        }, 200);
      }
    },
    drawRoute(self, route) {
      let path = self.parseRouteToPath(route);
      let startMarker = new AMap.Marker({
        position: path[0],
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/start.png",
        map: self.map
      });
      let endMarker = new AMap.Marker({
        position: path[path.length - 1],
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/end.png",
        map: self.map
      });
      let routeLine = new AMap.Polyline({
        path: path,
        isOutline: true,
        outlineColor: "#ffeeee",
        borderWeight: 2,
        strokeWeight: 5,
        strokeColor: "#ffffff",
        color: "#008000",
        lineJoin: "round"
      });
      routeLine.setMap(self.map);
      // 调整视野达到最佳显示区域
      self.map.setFitView([startMarker, endMarker, routeLine]);
    },
    parseRouteToPath(route) {
      let path = [];
      for (let i = 0, l = route.steps.length; i < l; i++) {
        let step = route.steps[i];
        for (let j = 0, n = step.path.length; j < n; j++) {
          path.push(step.path[j]);
        }
      }
      return path;
    }
  }
};
</script>
<style lang="scss" type="text/scss">
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  .s-h-icon {
    position: absolute;
    border: 1px solid #c9cbc6;
    background-color: #f3f7f8;
    cursor: pointer;
    z-index: 1;
  }
  .c-left {
    float: left;
    width: 200px;
    height: 100%;
    border-right: 1px solid #c9cbc6;
    background-color: #f3f7f8;
    position: relative;
    .s-h-icon {
      right: -13px;
      top: 50%;
      margin-top: -16px;
      border-left: unset;
      height: 48px;
      padding: 16px 0px;
      border-radius: 0 10px 10px 0;
    }
    .c-left-menu {
      .el-form {
        padding: 10px;
        .el-form-item {
          margin-bottom: 10px;
          .el-form-item__label {
            padding: 0;
          }
        }
      }
      .searchGroup {
        padding: 10px;
      }
      .playControlGroup {
        padding: 10px;
        border-top: 1px solid #c9cbc6;
        border-bottom: 1px solid #c9cbc6;
        font-weight: bold;
        font-size: 14px;
        color: #606266;
        > div {
          padding: 0 0 10px 0;
          .el-radio-group {
            .el-radio {
              margin-right: 15px;
              .el-radio__label {
                padding-left: 2px;
              }
            }
          }
          .el-button--medium.is-circle {
            padding: 0px;
            > i {
              font-size: 30px;
            }
          }
        }
      }
    }
    .el-icon-caret-left:before {
      margin: 0 -1px 0 -3px;
      display: block;
    }
    .el-icon-caret-right:before {
      margin: 0 -1px 0 -3px;
      display: block;
    }
  }
  .c-right {
    float: right;
    height: 100%;
    .c-r-head {
      height: 60px;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      position: absolute;
      z-index: 0;
    }
    .c-r-main {
      width: 100%;
      background-color: #0bb2d4;
    }
    .c-r-bottom {
      width: 100%;
      height: 200px;
      position: relative;
      .s-h-icon {
        right: 50%;
        top: -12px;
        border-bottom: unset;
        width: 48px;
        padding: 0 16px;
        border-radius: 10px 10px 0 0;
      }
      .el-icon-caret-top:before {
        margin: -2px 0 -2px 0;
        display: block;
      }
      .el-icon-caret-bottom:before {
        margin: -2px 0 -2px 0;
        display: block;
      }
      .c-bottom-menu {
        border-top: 1px solid #c9cbc6;
        background-color: #f3f7f8;
        height: 100%;
        width: 100%;
        .el-tabs {
          height: 100%;
          .el-tabs__header {
            margin-bottom: 0;
          }
          .el-tabs__content {
            height: 200px;
            .el-tab-pane {
              height: 200px;
            }
          }
        }
      }
    }
  }
  .amap-logo {
    opacity: 0;
  }
  .amap-copyright {
    opacity: 0;
  }
  .input-card {
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border-radius: 0.25rem;
    width: 22rem;
    border-width: 0;
    border-radius: 0.4rem;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 0.75rem 1.25rem;
    z-index: 1;
    .input-item {
      position: relative;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      -ms-flex-align: center;
      align-items: center;
      width: 100%;
      height: 2rem;
      font-size: 14px;
      .line {
        width: 2rem;
        height: 6px;
        border: 0;
      }
    }
  }
}
</style>
